import { isEmpty } from 'lodash';
import { BookingStates } from '../../../../../constants/booking-states';

export const shouldShowPriceCalc = (
  booking,
  currentContracts,
  pendingContracts
) => {
  if (isEmpty(currentContracts) && isEmpty(pendingContracts)) {
    return false;
  }

  const bookingPrice = booking.payout || booking.payment;
  const shouldShow =
    !!bookingPrice?.total &&
    ![
      BookingStates.CANCELLED,
      BookingStates.EXPIRED,
      BookingStates.DECLINED,
      BookingStates.WITHDRAWN
    ].includes(booking.obj_state);
  return shouldShow;
};
